import { gql } from '@apollo/client'

import { DROP_OFF_CHANNEL_FRAGMENT, DROP_OFF_LOCATION_FRAGMENT, LOCATION_FRAGMENT } from '..'

import { SHOP_CART_FULFILLMENT_ADDRESS_FRAGMENT } from './cartFulfillment/address'
import { SHOP_CART_FULFILLMENT_SCHEDULE_SETTING_FRAGMENT } from './cartFulfillment/scheduleSetting'

export const SHOP_CART_FULFILLMENT_FRAGMENT = gql`
  fragment ShopCartFulfillment on ShopCartFulfillment {
    address {
      ...ShopCartFulfillmentAddress
    }
    currentFulfillmentAt
    dropOffChannel {
      ...DropOffChannel
    }
    dropOffLocation {
      ...DropOffLocation
    }
    fulfillmentAt
    id
    kind
    courierAction
    location {
      ...Location
    }
    scheduleType
    scheduleSetting {
      ...ShopCartFulfillmentScheduleSetting
    }
    tableCode
  }
  ${SHOP_CART_FULFILLMENT_ADDRESS_FRAGMENT}
  ${DROP_OFF_CHANNEL_FRAGMENT}
  ${DROP_OFF_LOCATION_FRAGMENT}
  ${LOCATION_FRAGMENT}
  ${SHOP_CART_FULFILLMENT_SCHEDULE_SETTING_FRAGMENT}
`
